module.exports = __webpack_public_path__ + "img/nav-active.72b2a9ff.svg";